import { DeviceService } from "@/services/device.service";

const state = {
  devices: [],
  filters: [],
  device: null,
  screenshots: [],
  photoEvent: 0,
  applications: [],
  loadingState: null,
  appUploading: false,
  applicationsModal: false,
  isLandscape: false,
  orientationLoading: false,
  isHaveMarker: 0,
};
const mutations = {
  setDevices(state, value) {
    state.devices = value;
  },
  setFilters(state, value) {
    state.filters = value;
  },
  setDevice(state, value) {
    state.device = value;
  },
  setScreenshots(state, value) {
    state.screenshots = value;
  },
  setPhotoEvent(state) {
    state.photoEvent += 1;
  },
  setApplications(state, value) {
    state.applications = value;
  },
  setLoadingState(state, value) {
    state.loadingState = value;
  },
  setAppUploading(state, value) {
    state.appUploading = value;
  },
  setApplicationsModal(state, value) {
    state.applicationsModal = value;
  },
  changeScreenMode(state, value) {
    state.isLandscape = value;
  },
  changeOrientationLoading(state, value) {
    state.orientationLoading = value;
  },
  setIsHaveMarker(state, value) {
    state.isHaveMarker = value;
  },
};
const getters = {
  deviceList(state) {
    return state.devices;
  },
  getIsHaveMarker(state) {
    return state.isHaveMarker;
  },
  getOrientationLoading(state) {
    return state.orientationLoading;
  },
  filterList(state) {
    return state.filters;
  },
  screenIsLandscape(state) {
    return state.isLandscape;
  },
  device(state) {
    return state.device;
  },
  screenshots(state) {
    return state.screenshots;
  },
  photoEvent(state) {
    return state.photoEvent;
  },
  applications(state) {
    return state.applications;
  },
  loadingState(state) {
    return state.loadingState;
  },
  getAppUploading(state) {
    return state.appUploading;
  },
  applicationsModal(state) {
    return state.applicationsModal;
  },
};
const actions = {
  // eslint-disable-next-line no-unused-vars
  getDevices({ commit }) {
    return new Promise((resolve, reject) => {
      DeviceService.GetDevices()
        .then((r) => {
          commit("setDevices", r.data.result);
          resolve(r.data.result);
        })
        .catch((e) => {
          reject(e.message);
        });
    });
  },
  setMarker({ commit }, value) {
    commit("setIsHaveMarker", value);
  },
  changeScreenMode({ commit }, data) {
    return new Promise((resolve) => {
      commit("changeScreenMode", data.toLowerCase() === "landscape");
      resolve();
    });
  },
  changeOrientationLoading({ commit }, data) {
    commit("changeOrientationLoading", data);
  },
  triggerApplicationModal({ commit }, val) {
    commit("setApplicationsModal", val);
  },
  calculateUploadState({ commit }, data) {
    commit("setLoadingState", data);
  },
  getApplications({ commit }) {
    return new Promise((resolve) => {
      DeviceService.GetApplications().then((r) => {
        resolve(r.data.result);
        commit("setApplications", r.data.result);
      });
    });
  },

  // eslint-disable-next-line no-unused-vars
  removeApplication({ commit }, id) {
    return new Promise((resolve) => {
      DeviceService.RemoveApplication(id).then((r) => {
        resolve(r.data);
      });
    });
  },
  // eslint-disable-next-line no-unused-vars
  addApplication({ commit }, data) {
    commit("setAppUploading", true);
    this.appUploading = true;
    return new Promise((resolve, reject) => {
      DeviceService.AddApplication(data)
        .then((r) => {
          resolve(r.data);
        })
        .catch((e) => {
          reject(e.message);
        })
        .finally(() => commit("setAppUploading", false));
    });
  },
  // eslint-disable-next-line no-unused-vars
  abortAppUpload({ commit }) {
    return new Promise(() => {
      DeviceService.abortAppUpload();
    });
  },
  // eslint-disable-next-line no-unused-vars
  changeApplicationLabel({ commit }, data) {
    return new Promise((resolve, reject) => {
      DeviceService.ChangeApplicationLabel(data)
        .then((r) => {
          resolve(r.data);
        })
        .catch((e) => {
          reject(e.message);
        });
    });
  },
  // eslint-disable-next-line no-unused-vars
  renameApplication({ commit }, data) {
    return new Promise((resolve, reject) => {
      DeviceService.RenameApplication(data)
        .then((r) => {
          resolve(r.data);
        })
        .catch((e) => {
          reject(e.message);
        });
    });
  },
  spliceScreenshot({ commit }, data) {
    data.screenshots.splice(data.screenshots.length - 1, 1);
    commit("setScreenshots", data.screenshots);
  },
  pushScreenshot({ commit }, data) {
    data.screenshots.unshift(data.ss);
    commit("setScreenshots", data.screenshots);
  },
  clearScreenshot({ commit }) {
    commit("setScreenshots", []);
  },
  triggerPhotoEvent({ commit }) {
    commit("setPhotoEvent");
  },
  getDevice({ commit }, deviceId) {
    return new Promise((resolve) => {
      DeviceService.GetDevice(deviceId)
        .then((r) => {
          commit("setDevice", r.data.result);
          resolve(r.data.result);
        })
        .catch((e) => {
          resolve(e);
        });
    });
  },
  getFilters({ commit }) {
    DeviceService.GetDeviceFilters().then((r) => {
      if (!r.data.error) {
        const brandList = [];
        r.data.result.brands.forEach((brand) => {
          brandList.push({
            key: brand,
            value: brand,
          });
        });
        commit("setFilters", brandList);
      }
    });
  },
};

export default {
  state,
  mutations,
  getters,
  actions,
};
